import {
  GET_CUSTOM_SCRIPTS_SUCCESS
} from '../../constants/ActionTypes';

const INITIAL_STATE = {
  scripts: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOM_SCRIPTS_SUCCESS: {
      return {
        ...state,
        scripts: action.payload,
      }
    }
    default:
      return state;
  }
};
